import { render, staticRenderFns } from "./EnviosPostales.vue?vue&type=template&id=0fe63bd6&scoped=true"
import script from "./EnviosPostales.vue?vue&type=script&lang=js"
export * from "./EnviosPostales.vue?vue&type=script&lang=js"
import style0 from "./EnviosPostales.vue?vue&type=style&index=0&id=0fe63bd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe63bd6",
  null
  
)

export default component.exports